<template>
  <h4 class='categories'>
    {{ categories }}
  </h4>
</template>

<script>
export default {
  props: ['categories'],
}
</script>
